import React, { useEffect } from 'react';
import { Hero, TrustStrip, Services, WhyUs } from '../sections/HeroServicesWhy';
import { Areas, FinalCTA, FAQ, Testimonials, Credentials } from '../sections/RestSections';
import Seo from '../components/Seo';
import StructuredData from '../components/StructuredData';
import StickyBookBar from '../components/StickyBookBar';

export default function HomePage() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
          });
        },
        { threshold: 0.15 }
      );
      els.forEach((el) => io.observe(el));
      return () => io.disconnect();
    }
    els.forEach((el) => el.classList.add('in'));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount to reveal-animate sections
  }, []);

  useEffect(() => {
    // Scroll to hash target when arriving from another route
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount to honor an incoming hash
  }, []);

  return (
    <main>
      <Seo path="/" />
      <StructuredData faq />
      <Hero />
      <TrustStrip />
      <Services />
      <WhyUs />
      <Credentials />
      <Testimonials />
      <Areas />
      <FinalCTA />
      <FAQ />
      <StickyBookBar bookHref="/contact" bookLabel="Request Service" internal />
    </main>
  );
}
